import { invalid, valid } from "../validationUtils";
const timeslots = [
    'morning',
    'afternoon',
    'evening'
];
export const atLeastOneSlotMustBeSelected = function() {
    let message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "Select at least one time slot";
    return (input)=>input.morning || input.afternoon || input.evening ? valid : invalid(message);
};
export const initialTimeslotSelection = {
    morning: false,
    afternoon: false,
    evening: false
};
export const toggleTimeslot = (slot)=>(selection)=>{
        const updated = {
            ...selection
        };
        updated[slot] = !selection[slot];
        return updated;
    };
